const getters = {
    // sidebar: state => state.app.sidebar,
    globalScreenshotList: state => state.common.globalScreenshotList,
}
export default getters